import React from 'react';

const CLASS_BY_PRIORITY = {
  LOW: 'bg-slate-700/50 text-slate-200 border-slate-500/50',
  MEDIUM: 'bg-amber-500/20 text-amber-300 border-amber-500/60',
  HIGH: 'bg-orange-500/20 text-orange-300 border-orange-500/70',
  CRITICAL: 'bg-red-500/20 text-red-300 border-red-500/80',
};

const PriorityBadge = ({ priority }) => {
  const normalized = String(priority || 'LOW').toUpperCase();
  return (
    <span className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[11px] font-semibold ${CLASS_BY_PRIORITY[normalized] || CLASS_BY_PRIORITY.LOW}`}>
      {normalized}
    </span>
  );
};

export default PriorityBadge;
